<section class="p-6">

  <!-- Account Tabs -->
  <app-account-tabs></app-account-tabs>

  <form [formGroup]="profileForm">
    <div>

      <div class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
        <input type="file" #fileInput (change)="onFileSelected($event)" class="hidden">
        <div (click)="fileInput.click()" class="group block flex-shrink-0 cursor-pointer">
          <div class="flex items-center">
            <div>
              <img class="inline-block h-12 w-12 rounded-full" [src]=" user.profile_photo || 'https://ui-avatars.com/api/?name=' + user.name + '&background=d1d5dc&color=fff'"
                   (error)="onImageError($event)"
                   alt="">
            </div>
            <div class="ml-3">
              <p class="font-semibold text-secondary dark:text-primary-100">{{ user.name }}</p>
              <p class="text-sm text-gray-500 dark:text-primary-200">Change picture</p>
            </div>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-2 gap-6">

        <div class="col-span-2 md:col-span-1">
          <label for="first-name" class="block text-sm font-medium leading-6 text-secondary-900 dark:text-primary-200">Your name</label>
          <div class="mt-2">
            <input
              type="text"
              id="first-name"
              formControlName="name"
              autocomplete="given-name"
              class="input"
              [class.border-red-500]="profileSubmitted && p['name'].errors">
          </div>
          <div *ngIf="profileSubmitted && p['name'].errors" class="mt-1">
            <p *ngIf="p['name'].errors['required']" class="text-sm text-red-600 dark:text-red-400">
              Name is required
            </p>
            <p *ngIf="p['name'].errors['minlength']" class="text-sm text-red-600 dark:text-red-400">
              Name must be at least 2 characters long
            </p>
            <p *ngIf="p['name'].errors['maxlength']" class="text-sm text-red-600 dark:text-red-400">
              Name cannot exceed 100 characters
            </p>
            <p *ngIf="p['name'].errors['whitespace']" class="text-sm text-red-600 dark:text-red-400">
              Name cannot be only spaces
            </p>
          </div>
        </div>

        <div class="col-span-2 md:col-span-1">
          <label for="email" class="block text-sm font-medium leading-6 text-secondary-900 dark:text-primary-200">Email address</label>
          <div class="mt-2">
            <input disabled="disabled" id="email" name="email" type="email" autocomplete="email" [(ngModel)]="email" [ngModelOptions]="{standalone: true}" class="input bg-gray-100">
          </div>
        </div>

      </div>

    </div>

    <div class="my-6 flex items-center justify-end gap-x-3 mb-5">
      <button (click)="router.navigate(['/settings/account'])" type="button" class="btn btn-cancel">
        Cancel
      </button>
      <button type="submit" (click)="updateProfile()" class="btn btn-blue">
        Update Profile
      </button>
    </div>

  </form>

  <hr class="my-6"/>

  <form [formGroup]="passwordForm">
    <div>

      <div class="mt-6 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 p-5 bg-gray-50 dark:bg-secondary-800 rounded-md">
        <div class="col-span-12">
          <h2 class="text-base font-semibold leading-7 text-secondary dark:text-primary-200">Change password</h2>
          <p class="text-sm font-medium text-secondary/75 dark:text-primary-200">
            If you want to change your account password, type in your current password and the new password.
            Password must be at least 8 characters long and include uppercase, lowercase, and number.
          </p>
        </div>
      </div>

      <div class="mt-6 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
        <div class="col-span-6">
          <label for="current_password" class="block text-sm font-medium leading-6 text-secondary-900 dark:text-primary-200">Current Password</label>
          <div class="mt-2">
            <input
              id="current_password"
              formControlName="currentPassword"
              type="password"
              autocomplete="current-password"
              class="input"
              [class.border-red-500]="passwordSubmitted && f['currentPassword'].errors">
          </div>
          <div *ngIf="passwordSubmitted && f['currentPassword'].errors" class="mt-1">
            <p *ngIf="f['currentPassword'].errors['required']" class="text-sm text-red-600 dark:text-red-400">
              Current password is required
            </p>
          </div>
        </div>

        <div class="col-span-3">
          <label for="password" class="block text-sm font-medium leading-6 text-secondary-900 dark:text-primary-200">New Password</label>
          <div class="mt-2">
            <input
              id="password"
              formControlName="newPassword"
              type="password"
              autocomplete="new-password"
              class="input"
              [class.border-red-500]="passwordSubmitted && f['newPassword'].errors">
          </div>
          <div *ngIf="passwordSubmitted && f['newPassword'].errors" class="mt-1">
            <p *ngIf="f['newPassword'].errors['required']" class="text-sm text-red-600 dark:text-red-400">
              New password is required
            </p>
            <p *ngIf="f['newPassword'].errors['minlength']" class="text-sm text-red-600 dark:text-red-400">
              Password must be at least 8 characters long
            </p>
            <p *ngIf="f['newPassword'].errors['passwordStrength']" class="text-sm text-red-600 dark:text-red-400">
              Password must include uppercase, lowercase, and number
            </p>
          </div>
        </div>
        <div class="col-span-3">
          <label for="password_confirmation" class="block text-sm font-medium leading-6 text-secondary-900 dark:text-primary-200">Password Confirmation</label>
          <div class="mt-2">
            <input
              id="password_confirmation"
              formControlName="newPasswordConfirmation"
              type="password"
              autocomplete="new-password"
              class="input"
              [class.border-red-500]="passwordSubmitted && (f['newPasswordConfirmation'].errors || passwordForm.errors?.['passwordMismatch'])">
          </div>
          <div *ngIf="passwordSubmitted && f['newPasswordConfirmation'].errors" class="mt-1">
            <p *ngIf="f['newPasswordConfirmation'].errors['required']" class="text-sm text-red-600 dark:text-red-400">
              Password confirmation is required
            </p>
          </div>
          <div *ngIf="passwordSubmitted && passwordForm.errors?.['passwordMismatch'] && !f['newPasswordConfirmation'].errors" class="mt-1">
            <p class="text-sm text-red-600 dark:text-red-400">
              Passwords do not match
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-6 flex items-center justify-end gap-x-3">
      <button (click)="router.navigate(['/settings/account'])" type="button" class="btn btn-cancel">
        Cancel
      </button>
      <button type="submit" (click)="updatePassword()" class="btn btn-blue">
        Update Password
      </button>
    </div>
  </form>

  <hr class="my-6"/>

  <form>
    <div>

      <div class="mt-6 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 p-5 bg-gray-50 dark:bg-secondary-800 rounded-md">
        <div class="col-span-12">
          <h2 class="text-base font-semibold leading-7 text-secondary dark:text-primary-200">Research Area</h2>
          <p class="text-sm font-medium text-secondary/75 dark:text-primary-200">
            Please provide your main research area and Google domain. SalesOMMO uses this information to provide you with best results based on your geographical preferences.
          </p>
        </div>
      </div>

      <div class="mt-6 grid grid-cols-3 gap-6">

        <!-- Location -->
        <div class="col-span-2 md:col-span-1">
          <label for="location" class="block text-sm font-medium leading-6 text-secondary-900 dark:text-primary-200">Location</label>
          <div class="relative mt-2">
            <input
              id="location"
              name="location"
              type="text"
              [(ngModel)]="searchLocation"
              (ngModelChange)="onLocationSearchChange($event)"
              (focus)="onInputFocus()"
              class="w-full rounded-md border-0 bg-white py-1.5 pl-3 pr-12 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-royal sm:text-sm sm:leading-6"
              role="combobox"
              aria-controls="location-options"
              aria-expanded="false">
            <button type="button" class="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
              <svg class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M10 3a.75.75 0 01.55.24l3.25 3.5a.75.75 0 11-1.1 1.02L10 4.852 7.3 7.76a.75.75 0 01-1.1-1.02l3.25-3.5A.75.75 0 0110 3zm-3.76 9.2a.75.75 0 011.06.04l2.7 2.908 2.7-2.908a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 01.04-1.06z" clip-rule="evenodd" />
              </svg>
            </button>
            <ul *ngIf="dropdownOpen && filteredLocations.length" class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm" id="location-options" role="listbox">
              <li *ngFor="let location of filteredLocations" [value]="location.id" class="relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900" id="option-{{location.id}}" role="option" tabindex="-1" (click)="selectLocation(location)">
                <span class="block truncate">{{ location.canonical_name }}</span>
                <span *ngIf="selectedLocation === location.id" class="absolute inset-y-0 right-0 flex items-center pr-4 text-blue-royal">
                  <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clip-rule="evenodd" />
                  </svg>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <!-- / Location -->

        <!-- Domain -->
        <div class="col-span-2 md:col-span-1">
          <label id="domain-label" class="block text-sm font-medium leading-6 text-secondary-900 dark:text-primary-200">Domain</label>
          <div class="relative mt-2">
            <button
              type="button"
              class="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-royal sm:text-sm sm:leading-6"
              aria-haspopup="listbox"
              aria-expanded="true"
              aria-labelledby="domain-label"
              (click)="toggleDomainDropdown()">
              <span class="block truncate">{{ selectedDomain || 'Select domain' }}</span>
              <span class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                <svg class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M10 3a.75.75 0 01.55.24l3.25 3.5a.75.75 0 11-1.1 1.02L10 4.852 7.3 7.76a.75.75 0 01-1.1-1.02l3.25-3.5A.75.75 0 0110 3zm-3.76 9.2a.75.75 0 011.06.04l2.7 2.908 2.7-2.908a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 01.04-1.06z" clip-rule="evenodd" />
                </svg>
              </span>
            </button>
            <ul
              *ngIf="domainDropdownOpen"
              class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
              tabindex="-1"
              role="listbox"
              aria-labelledby="domain-label">
              <li
                *ngFor="let domain of filteredDomains$ | async"
                [attr.id]="'domain-option-' + domain.domain"
                class="relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900"
                role="option"
                (click)="selectDomain(domain)">
                <span class="block truncate">{{ domain.domain }}</span>
                <span *ngIf="selectedDomain === domain.domain" class="absolute inset-y-0 right-0 flex items-center pr-4 text-blue-royal">
                  <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clip-rule="evenodd" />
                  </svg>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <!-- / Domain -->

        <!-- Language -->
        <div class="col-span-2 md:col-span-1">
          <label id="language-label" class="block text-sm font-medium leading-6 text-secondary-900 dark:text-primary-200">Language</label>
          <div class="relative mt-2">
            <button
              type="button"
              class="relative w-full cursor-default rounded-md bg-gray-100 py-1.5 pl-3 pr-10 text-left text-gray-500 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-royal sm:text-sm sm:leading-6"
              aria-haspopup="listbox"
              aria-expanded="false"
              aria-labelledby="language-label"
              disabled>
              <span class="block truncate">{{ selectedLanguage || 'Select language' }}</span>
              <span class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
        <svg class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M10 3a.75.75 0 01.55.24l3.25 3.5a.75.75 0 11-1.1 1.02L10 4.852 7.3 7.76a.75.75 0 01-1.1-1.02l3.25-3.5A.75.75 0 0110 3zm-3.76 9.2a.75.75 0 011.06.04l2.7 2.908 2.7-2.908a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 01.04-1.06z" clip-rule="evenodd" />
        </svg>
      </span>
            </button>
            <!-- The following <ul> will be hidden as the button is disabled -->
            <ul
              *ngIf="false"
              class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
              tabindex="-1"
              role="listbox"
              aria-labelledby="language-label">
              <li
                *ngFor="let language of filteredLanguages$ | async"
                [attr.id]="'language-option-' + language.language_code"
                class="relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900"
                role="option">
                <span class="block truncate">{{ language.language_name }}</span>
                <span *ngIf="selectedLanguage === language.language_code" class="absolute inset-y-0 right-0 flex items-center pr-4 text-blue-royal">
                  <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clip-rule="evenodd" />
                  </svg>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <!-- / Language -->

      </div>

    </div>

    <div class="my-6 flex items-center justify-end gap-x-3 mb-5">
      <button (click)="router.navigate(['/settings/account'])" type="button" class="btn btn-cancel">
        Cancel
      </button>
      <button type="submit" (click)="updateSerpApi()" class="btn btn-blue">
        Update Research Area
      </button>
    </div>

  </form>

</section>
